import React from "react";
import { NavLink } from "react-router-dom";
import translate from "../Translation/i18nProvider/translate";

function Navbar() {
  return (
    <div className="NavBar">
      <nav className="nav">
        <div className="profile"></div>
        <ul className="nav-items">
          <li className="nav-item">
            <NavLink to="/" exact activeClassName="active">
              {translate("home_link")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/about" exact activeClassName="active">
              {translate("about_link")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/skills" exact activeClassName="active">
              {translate("skills_link")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/projects" exact activeClassName="active">
              {translate("projects_link")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/contact" exact activeClassName="active">
              {translate("contact_link")}
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Navbar;
